import script from "./LanguagePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguagePicker.vue?vue&type=script&setup=true&lang=js"

import "./LanguagePicker.vue?vue&type=style&index=0&id=7c0291c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c0291c4"]])

export default __exports__